import './App.css';
import { FrontItems } from './components/storefront.js';
import { CartContent } from './components/ScartContent';
import FinalForm from './components/FinalForm'
import { useState } from 'react';



const img = "https://media.discordapp.net/attachments/821291299479093248/877523074151497768/89d4044b5d00541fe8d1e1ac295b648068-17-blob-arms.png"
const img2 = "https://media.discordapp.net/attachments/322482500742152203/890639995940003880/unknown.png"
const img3 = "https://m.media-amazon.com/images/I/71fS2SBKk4L._AC_SL1500_.jpg"

let tuotteet = [{nimi: "a", img: img, hinta:10, desc: "abcd"},{nimi: "Muki", img: img3, hinta:100},{nimi: "lippis", img: img2, hinta:10}]

const App = () => {
  const [ShowCart, setShowCart] = useState(false);
  const [ShowForm, setShowForm] = useState(false);
  const [scart, setScart] = useState([]);
  const [Bought, Buy] = useState([]);

  const [ostajaData, setOstajaData] =  useState({});
  const shoppingCart = () => setShowCart(!ShowCart);
  const finalForm = () => {setShowForm(!ShowForm);setShowCart(false) };
  const ClearScart = () => setScart([])
  return (
    <div className="App">
      <header className="App-header">
        Fanikauppa
        <svg width="56" height="56" fill="currentColor" className="cart-plus" viewBox="0 0 16 16" onClick={shoppingCart}>
          <path d="M9 5.5a.5.5 0 0 0-1 0V7H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H9V5.5z"/>
          <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
        </svg>
      </header>


        <div className="main">
        
        <FrontItems tuotteet={tuotteet} scart={scart} setScart={setScart} />
            
        </div>
        {ShowCart ?
        <div className="Ostoskori">
          <div className="close"  onClick={shoppingCart}>X</div>
          <CartContent Scart = {scart} setScart={setScart}/>
          <button className="ostoNappi" onClick={finalForm}>Osta</button>
          <button className="ostoNappi" onClick={ClearScart}>Poista</button>
          kokonaishinta: {
            scart.length >0 ?
            scart.map((info) => info.info.hinta * info.num).reduce((a, b) => a + b)
            : 0
          }€
        </div>
        : null}
        {ShowForm ?
        <div className="form">
        <div className="close"  onClick={finalForm}>X</div>
          <FinalForm ostajaData={ostajaData} setOstajaData={setOstajaData} finalForm={finalForm} scart={scart} Buy={Buy} setScart={setScart}/>
        </div>
        : ostajaData.name ? 
        <div style={{display: "inline", textAlign: "start", width: "fit-content", margin: "auto"}}>
          Kiitos {ostajaData.name} ostoksestasi :D<br/>
          Tilaus: {Bought.map((info)=>info.num +" x "+ info.info.nimi + ", ")}<br/>
          Hinta: {
            Bought.length >0 ?
            Bought.map((info) => info.info.hinta * info.num).reduce((a, b) => a + b)
            : 0
          }€ <br />
          Toimitusosoite: {ostajaData.ppaikka}<br/>
        </div>
        : null}
    </div>
  );
}
export default App;
